import React, { useState, useEffect } from "react";
import { instance2 } from ".././utils/axiosInstance";
import { ReactComponent as EditIcon } from "../img/editicon.svg";
import { ReactComponent as VerticalLine } from "../img/verticalline.svg";
import { ReactComponent as MagnificationLogo } from "../img/magnificationlensicon.svg";
import { useNavigate, useLocation } from "react-router-dom";
import { formatNumber } from "../numberingformat";
import { EyeIcon } from '@heroicons/react/16/solid';

export default function TabelJadwalCustomer() {
  const navigate = useNavigate();
  const location = useLocation();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState(""); // Search input state
  const roleId = parseInt(localStorage.getItem("roleId"), 10);
  const kitchenId = parseInt(localStorage.getItem("kitchenId"), 10);
  const locationId = parseInt(localStorage.getItem("locationId"), 10);

  // Pagination States
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;

  // Edit Modal States
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [editedQtyReal, setEditedQtyReal] = useState("");
  const localDateString = (thedate) => {
    const year = thedate.getFullYear();
    const month = String(thedate.getMonth() + 1).padStart(2, '0'); // Adding 1 because months are 0-based
    const day = String(thedate.getDate()).padStart(2, '0');

    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let response;

if (roleId === 3 || roleId === 5) {
  response = await instance2.get(`/kitchen_pack_date/${kitchenId}`);
} else if (roleId === 4) {
  response = await instance2.get(`/kitchen_result/location/${locationId}`);
}
        setData(response.data);
      } catch (err) {
        setError(err.message || "Failed to fetch data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  const filteredData = data.filter((item) => {
    const formattedDate = new Date(item.date).toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "long",
      year: "numeric",
    }).toLowerCase();

    return [
  item.qty_real,
  item.qty,
  formattedDate,
  item.kitchen_name,
  item.location_name
].some(val =>
  String(val || '').toLowerCase().includes(searchQuery.toLowerCase())
);

  });

  const totalPages = Math.ceil(filteredData.length / itemsPerPage);
  const paginatedData = filteredData.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePreviousPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleNextPage = () => {
    if (currentPage < totalPages) setCurrentPage(currentPage + 1);
  };
// Determine which page numbers to show
let pageNumbers = [];
const maxVisiblePages = 5;

if (totalPages <= maxVisiblePages) {
  pageNumbers = Array.from({ length: totalPages }, (_, i) => i + 1);
} else {
  if (currentPage <= 3) {
    // Near the beginning
    pageNumbers = [1, 2, 3, 4, 5, "...", totalPages];
  } else if (currentPage >= totalPages - 2) {
    // Near the end
    pageNumbers = [1, "...", totalPages - 4, totalPages - 3, totalPages - 2, totalPages - 1, totalPages];
  } else {
    // In the middle
    pageNumbers = [1, "...", currentPage - 1, currentPage, currentPage + 1, "...", totalPages];
  }
}
  const handleEditClick = (item) => {
    setSelectedItem(item);
    setEditedQtyReal(item.qty_real);
    setIsEditModalOpen(true);
  };

  const handleSaveEdit = async () => {
    if (!selectedItem) return;

    try {
      const updatedData = {
        qty_real: editedQtyReal,
        admin_id: localStorage.getItem("userId"),
      };

      await instance2.put(`/dish_production/kitchen/${selectedItem.id}`, updatedData);

      // Update local state
      setData((prevData) =>
        prevData.map((item) =>
          item.id === selectedItem.id ? { ...item, qty_real: editedQtyReal } : item
        )
      );

      setIsEditModalOpen(false);
    } catch (error) {
      console.error("Failed to update qty_real:", error);
      alert("Failed to update data. Please try again.");
    }
  };

  return (
    <div className="p-4">
     <div className="mb-4">
  <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
    <h2 className="text-2xl font-medium">Tabel Rencana dan Hasil Produksi</h2>

    <div className="flex flex-col sm:flex-row gap-4">
      {(roleId === 3 || roleId===5)  && (
        <button
          type="button"
          onClick={() => navigate("/jadwalcustomer")}
          className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
        >
          Tambah Rencana Produksi
        </button>
      )}

      {[3, 4, 5].includes(roleId) && (
        <button
          type="button"
          onClick={() => navigate("/weeklyreport")}
          className="rounded-[25px] px-8 py-4 bg-merah-no hover:bg-merah-hover text-white text-xxs md:text-xxs lg:text-base"
        >
          Laporan Produksi
        </button>
      )}
    </div>
  </div>
</div>


      {loading && (
        <div className="flex justify-center py-8">
          <div className="w-6 h-6 border-2 border-gray-300 border-t-blue-500 rounded-full animate-spin"></div>
        </div>
      )}
      {error && <div className="text-center text-red-500">{error}</div>}

      {!loading && !error && data.length === 0 && (
        <p className="text-gray-500 text-center">No data available</p>
      )}

      {!loading && !error && data.length > 0 && (
        <div className="overflow-x-auto">
          {/* Search Bar */}

          <div className="pb-4 flex rounded-[50px] flex-row justify-start items-center gap-2 w-full md:w-auto">
                                  <div className="flex rounded-full p-2 bg-white text-gray-400 shadow-sm items-center w-full md:w-auto justify-start">
                                    <MagnificationLogo />
                                    <VerticalLine className="mx-1" />
                                    <input
                                      type="text"
                                      placeholder={`Telusuri data berdasarkan${roleId !== 3 && roleId !== 5 ? " nama dapur," : "" } rencana, realisasi, atau tanggal`}
                                      className="flex-1 bg-transparent outline-none border-none text-gray-800 px-2 focus:outline-none focus:ring-none focus:ring-transparent text-xxs md:text-xxs lg:text-base"
                                      style={{
                                        width: `${"Telusuri data berdasarkan nama dapur, koperasi, atau tanggal".length}ch`,
                                      }}
                                      value={searchQuery} // Controlled input
                                      onChange={(e) => setSearchQuery(e.target.value)} // Update search query
                                    />
                                  </div>
                                </div>

          <table className="min-w-full border-collapse">
            <thead className="bg-gray-200 text-xxs md:text-xxs lg:text-base">
              <tr className="bg-white">
                {/* <th className="border-b px-4 py-2">No</th> */}
                {  roleId !== 3 && roleId !== 5 ?
                <th className="border-b px-4 py-2 text-left ">Dapur</th>
               : ""}

                {/* <th className="border-b px-4 py-2 text-left ">Lokasi</th> */}
                <th className="border-b px-4 py-2 text-left w-1/3">Tanggal</th>
               <th className={`border-b px-4 py-2 w-1/3 ${(roleId !== 3 || roleId !== 5)? "text-right" : "text-center"}`}>Rencana (Porsi)</th>
                {/* {roleId === 3 || roleId === 5 || roleId === 4 ? (<th className="border-b px-4 py-2 w-1/4">Jumlah Institusi</th>) : "" }
                {roleId === 3 || roleId === 5 || roleId === 4 ? (<th className="border-b px-4 py-2 ">Realisasi (Porsi)</th>) : "" }
                {roleId === 3 || roleId === 5 || roleId === 4 ? (<th className="border-b px-4 py-2 w-1/4">Jumlah Institusi</th>) : "" } */}
                {roleId === 3 || roleId === 5 ? (<th className="border-b px-4 py-2">Rencana Produksi</th>) : "" }
                {roleId === 3 || roleId === 5 || roleId === 4 ? (<th className="border-b px-4 py-2">{roleId === 4 ? "Lihat Hasil" : "Download Berita Acara"}</th>) : "" }
               {/* {roleId === 3 || 5 ? (<th className="border-b px-4 py-2">Detail</th>) : "" }*/}
              </tr>
            </thead>
            <tbody>
              {paginatedData.map((item, index) => (
                <tr key={index} className={index % 2 === 0 ? "bg-transparent text-xxs md:text-xxs lg:text-base" : "bg-gray-50 text-xxs md:text-xxs lg:text-base"}>
                  {/* <td className="border-b px-4 py-2 text-center">{index + 1}</td> */}

                 { roleId !== 3 && roleId !== 5 ?
                   <td className="border-b px-4 py-2">{item.kitchen_name}</td>
                   : "" }
                  {/* <td className="border-b px-4 py-2">{item.location_name}</td> */}
                  <td className="border-b px-4 py-2">
                    {new Date(item.date).toLocaleDateString("id-ID", { year: "numeric", month: "long", day: "2-digit" })}
                  </td>
                  <td className="border-b px-4 py-2 text-right">
  {item.qty != null
    ? formatNumber(item.qty)
    : item.qty_sch > 0
    ? formatNumber(item.qty_sch)
    : "-"}
</td>

                   {/* {roleId === 3 || roleId === 5 || roleId === 4 ? (<td className="border-b px-4 py-2 text-center">{formatNumber(item.customer_count)}</td>) : "" }
                   {roleId === 3 || roleId === 5 || roleId === 4 ? (<td className="border-b px-4 py-2 text-right">{item.qty_real>0?formatNumber(item.qty_real):"-"}</td>) : "" }
                   {roleId === 3 || roleId === 5 || roleId === 4 ? (<td className="border-b px-4 py-2 text-center">{item.customer_real>0?formatNumber(item.customer_real):"-"}</td>) : "" } */}
                  {roleId === 3 || roleId === 5 ? (
                    <td className="border-b px-4 py-2 text-center">
    <button
      type="button"
      onClick={() =>
        navigate(
          `/jadwalcustomer?date=${encodeURIComponent(
            localDateString(new Date(item.date))
          )}`,
          { state: { from: location.pathname } } // pass previous path
        )
      }
      className="text-gray-500 p-2 rounded hover:text-green-500"
      aria-label="Edit jadwal customer"
    >
      <EditIcon className="w-5 h-5" />
    </button>
                  </td>

                  ) : ""} 
                  {roleId === 3 || roleId === 5 || roleId === 4  ? (
                    <td className="border-b px-4 py-2 text-center">
                    <button onClick={() => navigate(`/tambahhasilproduksi?date=${localDateString(new Date(item.date))}&kitchenId=${item.kitchen_id}`)} className="text-gray-500 p-2 rounded hover:text-green-500">
                           {(roleId === 3 || roleId === 5) ? (
  <EditIcon className="w-5 h-5" />
) : (
  <EyeIcon className="w-5 h-5" />
)}
                    </button>
                  </td>

                  ) : ""}
                {/*{roleId === 3 || 5 ? (
                    <td className="border-b px-4 py-2 text-center">
                    <button onClick={() => navigate(`/detailproduksiharian?date=${localDateString(new Date(item.date))}`)} className="text-gray-500 p-2 rounded hover:text-green-500">
                      <EyeIcon className="w-5 h-5" />
                    </button>
                  </td>
                ) : "" }*/}
                </tr>
              ))}
            </tbody>
          </table>

<div className="flex justify-center items-center mt-4 text-xs sm:text-sm">
      {/* Previous Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === 1
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handlePreviousPage}
        disabled={currentPage === 1}
      >
        <span className="font-bold text-lg sm:text-2xl">{"<"}</span>
      </button>

      {/* Page Numbers */}
      <div className="flex items-center">
        {pageNumbers.map((page, index) => (
          <span
            key={index}
            onClick={() => typeof page === "number" && setCurrentPage(page)}
            className={`mx-1 px-2 sm:px-3 py-1 cursor-pointer rounded-full ${
              currentPage === page ? "text-black font-semibold" : "text-gray-700"
            } ${page === "..." ? "cursor-default text-gray-400" : ""}`}
          >
            {page}
          </span>
        ))}
      </div>

      {/* Next Button */}
      <button
        className={`px-2 py-2 rounded ${
          currentPage === totalPages
            ? "text-gray-400 cursor-not-allowed"
            : "text-gray-500 hover:text-black"
        }`}
        onClick={handleNextPage}
        disabled={currentPage === totalPages}
      >
        <span className="font-bold text-lg sm:text-2xl">{">"}</span>
      </button>
    </div>
        </div>
      )}

      {isEditModalOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
          <div className="bg-white p-6 rounded-lg">
            <h2 className="text-lg font-bold mb-4">Ubah Kuantitas Realisasi</h2>
            <input
              type="number"
              value={editedQtyReal}
              onChange={(e) => setEditedQtyReal(e.target.value)}
              className="border p-2 w-full"
            />
            <div className="flex justify-end gap-4 mt-4">
              <button onClick={() => setIsEditModalOpen(false)} className="bg-gray-300 px-4 py-2 rounded">Cancel</button>
              <button onClick={handleSaveEdit} className="bg-blue-500 text-white px-4 py-2 rounded">Save</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
